module.exports = __webpack_public_path__ + "static/media/smx_logo.2087ccc7.svg";